import EmployerPrefEdit from "../Edits/EmployerPrefEdit";
import CmModal from "../Controls/CmModal";

export default function EmployerPrefEditModal({ preferenceId = 0, onClose }) {
  const id = Number.parseInt(preferenceId, 10) || 0;
  const title = id > 0 ? "Employer Preference" : "Add Employer Preference";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="employer-pref-edit-modal"
    >
      <EmployerPrefEdit preferenceId={id} onClose={onClose} />
    </CmModal>
  );
}
